















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Box extends Vue {
  @Prop({ type: String, default: '' }) readonly align?: string
  @Prop({ type: Boolean, default: false }) readonly spaceBottom?: boolean
  @Prop({ type: Boolean, default: false }) readonly miniSpaceBottom?: boolean
  @Prop({ type: Boolean, default: false }) readonly miniPadding?: boolean
  @Prop({ type: String, default: '' }) readonly customStyle?: string
}
